module.exports = __webpack_public_path__ + "static/media/princessCut_Diamond.1252b3b9.jpg";